<template>
  <div>
    <el-card
      class="left-box"
      body-style="height:calc(100vh - 150px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px"
      v-loading="loading"
    >
      <div
        style="
          height: 30px;
          margin-bottom: 10px;
          margin-top: 10px;
          width: 100%;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          position: relative;
          justify-content: space-between;
        "
      >
        <div>
          <el-input
            style="width: 300px"
            clearable
            v-model="searchData.Device"
            placeholder="请输入设备名称/编号"
          ></el-input>
          <!-- <el-input
          style="width: 300px; margin-left: 10px"
          v-model="searchData.InforType"
          clearable
          placeholder="请输入文件类型"
        ></el-input> -->
          <el-select
            v-model="searchData.InforType"
            filterable
            clearable
            placeholder="请选择文件类型"
            style="width: 300px; margin-left: 10px"
          >
            <el-option
              v-for="item in DeviceTypeList"
              :key="item.Id"
              :label="item.DicName"
              :value="item.DicName"
            ></el-option>
          </el-select>
          <el-input
            style="width: 300px; margin-left: 10px"
            v-model="searchData.InforName"
            clearable
            placeholder="请输入文件名称"
          ></el-input>
          <el-button type="primary" style="margin-left: 10px" @click="Search"
            >查询</el-button
          >
        </div>
        <div style="">
          <span class="Quantity">文件数量小计：{{ TotalQuantity }}</span>
          <span class="Quantity">文件数量总计：{{ SumQuantity }}</span>
        </div>
      </div>
      <div style="width: 100%">
        <el-table height="calc(100vh - 240px)" :data="dataList">
          <el-table-column
            type="index"
            label="序号"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="DeviceCode"
            label="设备编号"
            align="center"
            sortable
          />
          <el-table-column
            prop="DeviceName"
            label="设备名称"
            align="center"
            sortable
          />
          <el-table-column
            prop="SupplierName"
            label="供应商名称"
            align="center"
            sortable
          />

          <el-table-column
            prop="InforType"
            label="文件类型"
            align="center"
            sortable
          />
          <el-table-column
            prop="InforName"
            label="文件名称"
            align="center"
            sortable
            min-width="150"
          >
            <template slot-scope="scope">
              <!-- <el-button
                type="text"
                size="mini"
                @click="handleClick(scope.row)"
                >{{ scope.row.InforName }}</el-button
              > -->
              <a
                :href="scope.row.InforUrl"
                target="_blank"
                style="color: #409eff"
                >{{ scope.row.InforName }}</a
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="InforTime"
            label="提交时间"
            sortable
            align="center"
            :formatter="
              (row, column, cellValue) =>
                cellValue ? moment(cellValue).format('YYYY-MM-DD HH:mm:ss') : ''
            "
          />
        </el-table>
      </div>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      dataStatistics: {},
      dataList: [],
      searchData: {
        SupplierName: '',
        InforType: '',
        InforName: '',
        Device: '',
      },
      DeviceTypeList: [],
      loading: false,
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      backName: '',
      pId: '',
      SupplierId: '',
      devId: '',
      SumQuantity: '',
      TotalQuantity: '',
    }
  },
  props: {},
  components: {},
  methods: {
    getDeviceTypeList() {
      this.$http
        .post(
          '/Base_ProjectManage/Project_DictionaryMain/GetDocTypeDataList?dicKey=DeviceDocumentType',
          {}
        )
        .then((res) => {
          if (res.Success) {
            this.DeviceTypeList = res.Data || []
          }
        })
    },
    handleBack() {
      this.$emit('toDom', 'ProjectAll')
    },
    handleClick(row) {
      window.open(row.InforUrl)
    },
    Search() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    getDataList() {
      this.loading = true
      this.$http
        .post(`/Base_ProjectWork/Base_Project/GetDeviceInforList`, {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          Search: {
            ProjectId: this.pId,
            SupplierId: this.SupplierId,
            // DeviceType: this.devId,
            ...this.searchData,
          },
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.dataList = res.Data
            this.TotalQuantity = res.TotalQuantity || 0
            this.SumQuantity = res.SumQuantity || 0
            this.pagination.total = res.Total
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
  },
  mounted() {},
  created() {
    this.pId = this.$route.query.id
    this.backName = window.localStorage.getItem('ProjectName') || ''
    this.devId = this.$route.query.devId
    this.SupplierId = this.$route.query.ParentId
    this.getDeviceTypeList()
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .left-box {
  .el-card__header {
    padding: 10px;
    border: none;
  }
}
::v-deep .con .number {
  color: #e6a23c;
}
.head {
  height: 70px;
  // border-bottom: 1px solid #ccc;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-pagination__total {
  font-weight: bold;
  font-size: 18px !important;
}
.Quantity {
  font-weight: bold;
  font-size: 18px;
  margin-right: 20px;
  color: #606266;
}
</style>
